const ROOT = 'Login/login/user';

export const FETCH_LOGIN_REQUEST = `${ROOT}/FETCH_LOGIN_REQUEST`;
export const FETCH_LOGIN_SUCCESS = `${ROOT}/FETCH_LOGIN_SUCCESS`;
export const FETCH_LOGIN_FAILURE = `${ROOT}/FETCH_LOGIN_FAILURE`;
